export const AdminRoleType = {
  ADMIN_BASIC: "ADMIN_BASIC",
} as const;

export type AdminRoleTypeString =
  (typeof AdminRoleType)[keyof typeof AdminRoleType];
